import React from 'react';
import RemoteDesktopSection from './RemoteDesktopSection.temporary';
import ProvisioningScriptSection from './ProvisioningScriptSection.temporary';
import AutoUpdateCheckbox from './AutoUpdateCheckbox';
import GlobalProvisionScriptsPreview from './GlobalProvisionScriptsPreview';
import ClusterApplicationsSection from './ClusterApplicationsSection';
import { columnContainerStyle, columnStyle } from './formLayoutStyles';

/**
 * The standard advanced-mode sections shared across all provider forms:
 * Remote Desktop + Provisioning Script (two columns), AutoUpdate,
 * Global Provision Scripts, Cluster Applications.
 */
export default function AdvancedSectionsBlock({ form, setForm, setField, provider, advanced, marketplace, disableInputs }) {
    return (
        <>
            {advanced && (
                <div style={columnContainerStyle}>
                    <div style={columnStyle}>
                        <RemoteDesktopSection form={form} setField={setField} provider={provider} fillHeight />
                    </div>
                    {!marketplace.hideProvisionScript && (
                        <div style={columnStyle}>
                            <ProvisioningScriptSection
                                form={form} setField={setField} provider={provider} fillHeight
                                disabled={disableInputs}
                            />
                        </div>
                    )}
                </div>
            )}

            {advanced && <AutoUpdateCheckbox form={form} setForm={setForm} />}

            {(advanced || marketplace.disableGlobalScripts) && (
                <div style={marketplace.disableGlobalScripts ? { display: 'none' } : undefined}>
                    <GlobalProvisionScriptsPreview
                        provider={provider} osType={form.osType || ''} clusterName={form.hostname || ''}
                        clusterId={form.id} excludedScripts={form.excludedGlobalScripts || []}
                        onExcludedScriptsChange={(scripts) => setField('excludedGlobalScripts', scripts)}
                        disabled={disableInputs || marketplace.disableGlobalScripts}
                    />
                </div>
            )}

            {(advanced || (form.applications?.length > 0)) && (
                <ClusterApplicationsSection
                    applications={form.applications || []}
                    onChange={(apps) => setField('applications', apps)}
                    disabled={disableInputs}
                />
            )}
        </>
    );
}
